"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SqlGenerator = void 0;
exports.createGenerator = createGenerator;
const dialects_1 = require("./dialects");
const generator_1 = require("./generator");
function createGenerator(options) {
    return new generator_1.SqlGenerator(options, dialects_1.DIALECTS[options.dialect]);
}
var generator_2 = require("./generator");
Object.defineProperty(exports, "SqlGenerator", { enumerable: true, get: function () { return generator_2.SqlGenerator; } });
//# sourceMappingURL=index.js.map